export default __webpack_public_path__ + "static/media/mftv_start.b567c7a4.svg";